



















































































import Vue from "vue";
import GetterTypes from "@/store/GetterTypes";
import { mapGetters } from "vuex";
import OrganizationSelectors from "@/components/PlayerAndTeamsSelector/components/OrganizationSelectors.vue";
import PlayerSelectors from "@/components/PlayerAndTeamsSelector/components/PlayerSelectors.vue";
import { Player, UserOrganizationsAndTeams } from "@/types";
import PlayerAccessRequest from "@/components/PlayerAndTeamsSelector/components/PlayerAccessRequest.vue";

interface RecentSelection {
  orgId: string;
  teamId: string;
  name: string;
}
interface State {
  recentIds: RecentSelection[];
}
export default Vue.extend({
  name: "PlayerAndTeamSelectionView",
  components: { PlayerAccessRequest, PlayerSelectors, OrganizationSelectors },
  data(): State {
    return {
      recentIds: []
    };
  },
  mounted() {
    this.recentIds = this.fetchRecentIds();
  },
  methods: {
    fetchRecentIds(): RecentSelection[] {
      if (!this.user) return [];

      const json = localStorage.getItem(this.user.id + "-recentIds");

      if (!json) return [];

      const data = JSON.parse(localStorage[this.user.id + "-" + "recentIds"]);
      return data.filter((recent: RecentSelection) => {
        return (
          this.playersAndTeams.organizations.find(
            (org: UserOrganizationsAndTeams) => {
              return (
                org.id === recent.orgId &&
                org.teams.find(team => {
                  return team.id === recent.teamId;
                })
              );
            }
          ) !== undefined
        );
      });
    },
    storeRecentIds(): void {
      if (this.user) {
        localStorage[this.user.id + "-" + "recentIds"] = JSON.stringify(
          this.recentIds
        );
      }
    },
    hide(): void {
      this.$emit("hide");
    },
    select({ orgId, teamId, name }: RecentSelection): void {
      this.$emit("select", { orgId, teamId });

      if (!name) return;

      this.recentIds = this.recentIds.filter(recent => {
        return (
          recent.orgId !== orgId ||
          (recent.orgId === orgId && recent.teamId !== teamId)
        );
      });
      this.recentIds = [{ orgId, teamId, name }, ...this.recentIds].slice(0, 6);
      this.storeRecentIds();
    }
  },
  computed: {
    activePlayers(): Player[] {
      //player will be considered inactive if all their teams have a date archived
      return this.playersAndTeams.players.filter((player: Player) => {
        return player.orgUnits.find(orgUnit => {
          return !orgUnit.isOrganization && !orgUnit.dateArchived;
        });
      });
    },
    activeFollowedPlayers(): Player[] {
      return this.playersAndTeams.following.filter((player: Player) => {
        return player.orgUnits.find(orgUnit => {
          return !orgUnit.isOrganization && !orgUnit.dateArchived;
        });
      });
    },
    isFanViewVisible(): boolean {
      return (
        this.activePlayers.length > 0 || this.activeFollowedPlayers.length > 0
      );
    },
    organizations(): boolean {
      return this.playersAndTeams && this.playersAndTeams.organizations;
    },
    ...mapGetters({
      playersAndTeams: GetterTypes.GET_PLAYERS_AND_TEAMS,
      user: GetterTypes.GET_USER
    })
  }
});
